// extracted by mini-css-extract-plugin
export var progressBar = "_ic-0";
export var progressBarInner = "_ic-1";